import clsx from "clsx";
import RootLayout from "layouts/RootLayout";
import React, { useState } from "react";
import Select from "react-select";
import { clinicList } from "utils";
import BasicModal from "components/BasicModal";

const ClinicList = () => {
  const optionList = clinicList.map(c => ({ label: c.area, value: c.area }));
  const [areaOption, setAreaOption] = useState(optionList[0]);

  const selectedClinicList = clinicList.find(c => c.area === areaOption.value);

  const handleOpenGoogleMap = (address: string, map: string) => {

    const encodedAddress = encodeURIComponent(address);
    const googleMapsUrl = map || `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

    window.open(googleMapsUrl, '_blank', 'noopener,noreferrer');
  }

  return (
    <RootLayout title="就醫資訊 - 診所列表">
      <div className="mx-7 mt-1.5 mb-9 space-y-3">
        <Select
          className="text-2xl bg-[#E0E0E0]"
          options={optionList}
          onChange={option => {
            setAreaOption(option);
          }}
          value={areaOption}
        />
        {selectedClinicList.clinics.map(c => (
            <div
                className={clsx(
                    "p-[5px] h-[200px] flex flex-col space-y-[5px]",
                    "border border-[#00000033] rounded-[5px]",
                    "text-[#555555] font-normal"
                )}
            >
              <div
                  className={clsx(
                      "px-9 flex items-center flex-1",
                      "bg-[#FCE4EC7F] rounded-t-[5px]",
                      "text-xl text-[#0000ff]"
                  )}
              >
                {c.name}
              </div>
              <div
                  className={clsx(
                      "px-2.5 flex items-center flex-1",
                      "bg-[#0000000F] text-lg"
                  )}
              >
              <span className="mr-1">
                <img src="/img/phone.png" alt=""/>
              </span>
                <span>{c.telephone}</span>
              </div>
              <div
                  className={clsx(
                      "px-2.5 flex items-center justify-between flex-1",
                      "bg-[#FCE4EC80]"
                  )}
              >
                <div className="flex items-center">
                <span className="mr-1">
                  <img src="/img/entypo_address.png" alt=""/>
                </span>
                  <span>{c.address}</span>
                </div>
                <div onClick={() => handleOpenGoogleMap(c.address, c.map)}>
                  <img src="/img/google-maps.png" alt=""/>
                </div>

              </div>
              <div
                  className={clsx(
                      "px-2.5 flex items-center flex-1",
                      "bg-[#0000000F] text-lg"
                  )}
              >
              <span className="mr-1">
                　
              </span>
                <BasicModal title={`${c.name} 服務時段`} serviceInfo={c.serviceInfo ?? undefined}></BasicModal>
              </div>
            </div>
        ))}
      </div>
    </RootLayout>
  );
};

export default ClinicList;
